import { api } from "@/api/client";
import type {
  CreateLoginPayload,
  EditLoginPayload,
  ToggleLoginsVisibilityRequestPayload,
} from "@/api/mutations/logins/types";
import { queryKeys } from "@/api/queryKeys";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useCreateLogin = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: CreateLoginPayload) =>
      api.post("/logins/create-login", payload).then((res) => res.data),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [queryKeys.getLogins] });
    },
  });
};

export const useEditLogin = (loginId: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: EditLoginPayload) =>
      api.put(`/logins/edit-login/${loginId}`, payload).then((res) => res.data),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [queryKeys.getLogins] });
    },
  });
};

export const useEnableLogin = (loginId: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => api.post(`/logins/enable-login/${loginId}`).then((res) => res.data),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [queryKeys.getLogins] });
    },
  });
};

export const useDisableLogin = (loginId: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ reason }: { reason?: string }) =>
      api.post(`/logins/disable-login/${loginId}`, { reason }).then((res) => res.data),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [queryKeys.getLogins] });
    },
  });
};

export const useToggleLoginsVisibility = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: ToggleLoginsVisibilityRequestPayload) =>
      api.put(`/logins/toggle-login-visibility`, payload).then((res) => res.data),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [queryKeys.getLogins] });
    },
  });
};

export const useStartLogin = (loginId: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => api.post(`/logins/start-login/${loginId}`).then((res) => res.data),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [queryKeys.getLogins] });
    },
  });
};

export const useStopLogin = (loginId: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => api.post(`/logins/stop-login/${loginId}`).then((res) => res.data),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [queryKeys.getLogins] });
    },
  });
};
